import { styled } from "@mui/material/styles";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import { theme } from "styles/themes";

export const SegmentedGroup = styled(ToggleButtonGroup)(() => ({
  backgroundColor: theme.colors.grey,
  borderRadius: "22px",
  padding: "4px",
  gap: "2px",
}));

export const Segment = styled(ToggleButton)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  border: "none",
  borderRadius: "18px !important",
  padding: "7px 18px",
  fontFamily: "Barlow",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "17px",
  textTransform: "none",
  whiteSpace: "nowrap",
  color: theme.colors["queen-blue"],
  "&:hover": {
    backgroundColor: "transparent",
    color: theme.colors["dark-blue"],
  },
  "&.Mui-selected": {
    backgroundColor: theme.colors.white,
    color: theme.colors["blue-ribbon"],
    boxShadow: "0 1px 4px rgba(0, 33, 96, 0.12)",
    "&:hover": {
      backgroundColor: theme.colors.white,
    },
  },
}));
